import React from "react";
import ActionHeaderCell from "../components/cells/action-header-cell/ActionHeaderCell";
export const getTableActionColumnOptions = (customActionRenderer, location) => {
  const isOnboardingDetail = (location === null || location === void 0 ? void 0 : location.pathname) === "/onboarding/detail";
  return {
    name: "Actions",
    options: {
      customHeadRender: function head(value) {
        return /*#__PURE__*/React.createElement(ActionHeaderCell, {
          align: "center",
          key: value.index
        });
      },
      customBodyRender: customActionRenderer,
      setCellProps: () => {
        return {
          style: {
            right: 0,
            zIndex: 101,
            position: "sticky",
            backgroundColor: isOnboardingDetail ? " " : "#fff",
            width: 100
          }
        };
      },
      viewColumns: false,
      download: false,
      filter: false,
      sort: false,
      searchable: false
    }
  };
};